import { FC, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Grid } from 'antd';

import CardArticle from 'src/components/Home/Article/CardArticle';
import MainArticle from 'src/components/Home/Article/MainArticle';
import ImageC from 'src/components/Image';
import SpinC from 'src/components/Layout/Spin';
import { DEFAULT_PAGE_INDEX, DEFAULT_PER_PAGE } from 'src/constants/pagination';
import useInsiderTrackingCategory from 'src/hooks/useInsiderTrackingCategory';
import { IArticleByGroupDetail } from 'src/interface/ArticleByGroup';
import { actionGetArticleByCategorySlug } from 'src/redux/actions/articleByGroup';
import { removeQueryParams } from 'src/utils/func/format-query';

import classes from './style.module.css';

const ParentCategory: FC = () => {
	const { xs } = Grid.useBreakpoint();

	const { articleByGroup, loader } = useSelector((state: RootStateOrAny) => state);
	const articles = articleByGroup?.articleByCategory || {};

	const [articlesPublic, setArticlesPublic] = useState<IArticleByGroupDetail[]>(
		articles?.data?.records,
	);
	const totalPage: number = articles?.meta?.pagination?.total_page || 0;

	const [pagination, setPagination] = useState({
		page: DEFAULT_PAGE_INDEX,
		per_page: DEFAULT_PER_PAGE,
	});

	const dispatch = useDispatch();
	const router = useRouter();

	const getArticles = async (slug: string) => {
		dispatch(
			await actionGetArticleByCategorySlug(slug, {
				should_show_headline: true,
				...pagination,
			}),
		);
	};

	useEffect(() => {
		getArticles(router.query.sub as string);
	}, []);

	useEffect(() => {
		if (router.pathname && pagination.page > 1) {
			getArticles(router.query.sub as string);
		}
	}, [router.pathname, pagination]);

	useEffect(() => {
		if (articles?.meta?.pagination?.page > 1 && articles?.data?.records?.length) {
			setArticlesPublic([...articlesPublic, ...articles?.data?.records]);
		}
	}, [articles?.meta?.pagination?.page]);

	useInsiderTrackingCategory('articles', articlesPublic);

	return (
		<div className={`${classes['article-wrapper']}`}>
			<MainArticle
				data={articlesPublic?.[0] as IArticleByGroupDetail}
				subCategory={removeQueryParams(router.asPath)}
				headingLevel={2}
			/>

			<div className={classes.section}>
				<CardArticle
					data={articlesPublic as IArticleByGroupDetail[]}
					length={articlesPublic?.length}
					subCategory={removeQueryParams(router.asPath)}
					headingLevel={2}
				/>
			</div>

			{pagination.page < totalPage && (
				<div
					className={classes.viewMore}
					onClick={() =>
						setPagination((prev) => ({
							...prev,
							page: prev.page + 1,
							per_page: 10,
						}))
					}
				>
					{loader?.sending ? (
						<SpinC />
					) : (
						<>
							<p>Muat lebih banyak</p>
							<ImageC
								alt="arrow-down-short"
								src="/icons/arrow-down-short.svg"
								height={xs ? 24 : 32}
								width={xs ? 24 : 32}
							/>
						</>
					)}
				</div>
			)}
		</div>
	);
};

export default ParentCategory;
